import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "../components/Logo";

const Section = ({ title, children }) => (
  <div className="mt-6">
    <h2 className="text-base font-bold text-[#0A1128]">{title}</h2>
    <div className="mt-1.5 space-y-2 text-sm leading-relaxed text-[#4A5568]">{children}</div>
  </div>
);

export default function Impressum() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto min-h-screen max-w-md bg-[#F8F9FA]" data-testid="impressum-page">
      <div className="flex items-center justify-between px-6 pb-2 pt-[calc(env(safe-area-inset-top)+1.5rem)]">
        <button data-testid="back-btn" onClick={() => navigate(-1)} className="flex h-10 w-10 items-center justify-center rounded-full text-[#0A1128] transition-colors hover:bg-black/5">
          <ArrowLeft size={22} />
        </button>
        <Logo />
        <div className="w-10" />
      </div>

      <div className="px-7 pb-16 pt-6">
        <div className="mb-1 h-px w-12 bg-[#C5A059]" />
        <h1 className="font-display text-4xl font-light tracking-tight text-[#0A1128]">Impressum</h1>

        <Section title="Angaben gemäß § 5 DDG">
          <p>Steffen Hermes<br />Lingener Str. 54<br />48531 Nordhorn</p>
        </Section>

        <Section title="Kontakt">
          <p>E-Mail: webmaster@empfehlungs-kompass.de<br />Website: https://empfehlungs-kompass.de</p>
        </Section>

        <Section title="Verantwortlich für den Inhalt">
          <p>Steffen Hermes, Lingener Str. 54, 48531 Nordhorn</p>
        </Section>

        <Section title="Haftungshinweis">
          <p>Für die Inhalte externer Links wird trotz sorgfältiger Prüfung keine Haftung übernommen. Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
        </Section>

        <Section title="EU-Streitschlichtung">
          <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse findest du oben im Impressum.</p>
        </Section>

        <Section title="Verbraucherstreitbeilegung">
          <p>Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </Section>
      </div>
    </div>
  );
}
